<div class="burger-menu" (click)="toggle()">
  <div class="burger-menu__icon"
       [ngClass]="{open: burger.isOpen}">
    <span class="line"></span>
    <span class="line"></span>
  </div>
</div>
